<template>
  <div id="hres4ax">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres4axIndex"
            :detailEvent="detailEvent"
            searchBoxAlias="hres4ax" />
    <detail v-if="detailDisp"
            :nowLang="app.nowLang"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :receivedOrgBodyDetail="receivedOrgBodyDetail" />
    <button type="button" class="hidden btn bg-color-skin pull-right" data-toggle="modal" data-target="#hres4ax-popup1" ref="hres4axPopup1"></button>

    <popup1 :nowLang="app.nowLang"
            :labels="labels[app.nowLang]"
            :popup1="popup1"
            :popup1Tab1Table="columns[app.nowLang].popup1Tab1Table"
            :popup1Tab2Table="columns[app.nowLang].popup1Tab2Table"
            :popup1Tab3Table="columns[app.nowLang].popup1Tab3Table"
            :detail="detail"
            :popup2="popup2"
            :popup2Tab2Table="columns[app.nowLang].popup2Tab2Table"
            :popup2Tab3Table="columns[app.nowLang].popup2Tab3Table" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres4ax/mutation-types'
import detail from 'components/hres4ax/detail'
import popup1 from 'components/hres4ax/popup1'
import moment from 'moment'

export default {
  name: 'hres4ax',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        codcompy: '',
        dteeffest: '01/' + moment().format('MM/YYYY'),
        dteeffeen: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHres4axColumnsLabels()
    // this.receivedHres4axIndex(this.searchIndex)
  },
  computed: {
    ...mapGetters({
      indexDisp: types.GET_HRES4AX_INDEX_DISP,
      detailDisp: types.GET_HRES4AX_DETAIL_DISP,
      columns: types.GET_HRES4AX_COLUMNS,
      labels: types.GET_HRES4AX_LABELS,
      index: types.GET_HRES4AX_INDEX,
      indexSelected: types.GET_HRES4AX_INDEX_SELECTED,
      detail: types.GET_HRES4AX_DETAIL,
      popup1: types.GET_HRES4AX_POPUP1,
      popup2: types.GET_HRES4AX_POPUP2
    })
  },
  methods: {
    receivedOrgBodyDetail (dataRow) {
      this.$refs.hres4axPopup1.click()
      this.receivedHres4axPopup1(dataRow)
      this.receivedHres4axPopup2(dataRow)
    },
    detailEvent (dataRow) {
      this.setIndexSelected(dataRow)
      this.receivedHres4axDetail(dataRow)
      this.toggle('detail')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES4AX_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES4AX_PAGE,
      receivedHres4axColumnsLabels: types.RECEIVED_HRES4AX_COLUMNS_LABELS,
      receivedHres4axIndex: types.RECEIVED_HRES4AX_INDEX,
      receivedHres4axDetail: types.RECEIVED_HRES4AX_DETAIL,
      receivedHres4axPopup1: types.RECEIVED_HRES4AX_POPUP1,
      receivedHres4axPopup2: types.RECEIVED_HRES4AX_POPUP2
    })
  },
  components: {
    detail,
    popup1
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?2fd58696